import { Filter } from 'components/FilterDrawer/FilterDrawer.config'
import axios from 'services/axios'
import apiService from './api'

export const EMPLOYEES_EXPORT_TYPES = {
  SUMMARY: 'summary',
  DETAILED: 'detailed',
} as const

export type EmployeesExportType = (typeof EMPLOYEES_EXPORT_TYPES)[keyof typeof EMPLOYEES_EXPORT_TYPES]

interface EmployeesExportParams {
  employeesIndices: string
  entityId: string
  vertical: string
  filters?: Filter[]
  searchValue?: string
  exportType?: EmployeesExportType
}

export const employeesExport = async ({
  employeesIndices,
  entityId,
  vertical,
  filters,
  searchValue,
  exportType,
}: EmployeesExportParams) => {
  const endpoint = 'employees/export'

  if (!employeesIndices || !entityId) return

  const params: Record<string, any> = {
    employeesIndices,
    entityId,
    vertical,
  }

  if (filters && filters.length > 0) {
    params.filters = filters
  }
  if (searchValue) {
    params.searchValue = searchValue
  }
  if (exportType) {
    params.exportType = exportType
  }

  try {
    const { data } = await axios.get(endpoint, { params })
    return data
  } catch (err) {
    apiService.handleApiError(err as object | undefined)
    throw new Error('Failed to fetch data')
  }
}

interface EmployeesExportCountParams {
  employeesIndices: string
  entityId: string
  filters?: Filter[]
  searchValue?: string
}

export const employeesExportCount = async ({
  employeesIndices,
  entityId,
  filters,
  searchValue,
}: EmployeesExportCountParams): Promise<number> => {
  const endpoint = 'employees/export/count'

  if (!employeesIndices || !entityId) return 0

  const params: Record<string, any> = {
    employeesIndices,
    entityId,
  }

  if (filters && filters.length > 0) {
    params.filters = filters
  }
  if (searchValue) {
    params.searchValue = searchValue
  }

  try {
    const { data } = await axios.get(endpoint, { params })
    return data.total
  } catch (err) {
    apiService.handleApiError(err as object | undefined)
    return 0
  }
}
